import GlobalVariables from '../GlobalVariables';
import configureGoogleAnalytics4 from './configureGoogleAnalytics4';
import localstorageAPIExists from './localstorageAPIExists';
import RunAsSoonAsWithDelay from './RunAsSoonAsWithDelay';
import getCookieValue from './getCookieValue';

const saveGoogleAnalyticsClientId = (measurementId) => {
    if (!measurementId) {
        return;
    }
    if (!localstorageAPIExists('livechat_gaClientId')) {
        configureGoogleAnalytics4(measurementId);
        window.dataLayer = window.dataLayer || [];
        const gtag = () => {
            window.dataLayer.push(arguments);
        };

        if (typeof RunAsSoonAsWithDelay === "function") {
            gtag('get', measurementId, 'client_id', (clientId) => {
                ApexChat.localStorageAPI.Store('livechat_gaClientId', clientId);
                RunAsSoonAsWithDelay(() => {
                    let xhr = new XMLHttpRequest();
                    xhr.open(
                        'GET',
                        `${GlobalVariables.LiveChatServiceUrl
                        }handlers/googleanalyticshandler.ashx?clientId=${clientId}&visitorId=${getCookieValue(
                            'livechat_visitor_id'
                        )}`
                    );
                    xhr.send();
                }, function () {
                    return getCookieValue('livechat_visitor_id') != 'undefined';
                },
                    1000);
            });
        }
    }
};
export default saveGoogleAnalyticsClientId;
